import { useTranslation } from "react-i18next";

interface ProvisioningStep {
  name: string;
  completed: boolean;
}

interface ProvisioningProgressProps {
  steps?: ProvisioningStep[];
  currentStep?: number;
}

export function ProvisioningProgress({ steps, currentStep = 0 }: ProvisioningProgressProps) {
  const { t } = useTranslation();

  const defaultSteps: ProvisioningStep[] = [
    { name: t('dashboard.provisioning.creatingServer'), completed: false },
    { name: t('dashboard.provisioning.waitingForBoot'), completed: false },
    { name: t('dashboard.provisioning.configuringDns'), completed: false },
    { name: t('dashboard.provisioning.startingCloseCode ADE'), completed: false },
    { name: t('dashboard.provisioning.verifyingHealth'), completed: false },
  ];

  const displaySteps = steps ?? defaultSteps;

  return (
    <div className="space-y-3">
      {displaySteps.map((step, index) => {
        const isActive = index === currentStep;
        const isCompleted = step.completed || index < currentStep;

        return (
          <div key={step.name} className="flex items-center gap-3">
            <div className="flex-shrink-0">
              {isCompleted ? (
                <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center">
                  <svg
                    className="w-3.5 h-3.5 text-green-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
              ) : isActive ? (
                <div className="w-6 h-6 rounded-full bg-blue-500/20 flex items-center justify-center">
                  <div className="w-3 h-3 border-2 border-blue-400 border-t-transparent rounded-full animate-spin" />
                </div>
              ) : (
                <div className="w-6 h-6 rounded-full bg-[#333] flex items-center justify-center">
                  <div className="w-2 h-2 rounded-full bg-[#666]" />
                </div>
              )}
            </div>
            <span
              className={`text-sm ${
                isCompleted
                  ? "text-green-400"
                  : isActive
                    ? "text-blue-400 font-medium"
                    : "text-[#666]"
              }`}
            >
              {step.name}
              {isActive && "..."}
            </span>
          </div>
        );
      })}
    </div>
  );
}
